import { LowerCasePipe } from '@angular/common';
import { Component, computed, inject, input, output } from '@angular/core';
import { Wk8BookService } from '@core/wk8/wk8-book.service';
import { IDraggable } from '@features/drag-and-drop/drag-and-drop.types';
import { LpDropTargetDirective } from '@features/lp/lp-drag-and-drop/lp-drop-target.directive';
import { LpVariablesService } from '@features/lp/lp-variables/lp-variables.service';
import { Wk8BookTextComponent } from '@features/wk8/wk8-book/wk8-book-text/wk8-book-text.component';
import { TrimPipe } from '@shared/strip-whitespace.pipe';
import { LpWk8BookSentence, LpWk8BookSentencePart, LpWk8BookSentencePartFilter, LpWoordData } from '@typings/lp/generated';

@Component({
  selector: 'wk8-book-sentence',
  imports: [LpDropTargetDirective, LowerCasePipe, TrimPipe, Wk8BookTextComponent],
  templateUrl: './wk8-book-sentence.component.html',
  styleUrl: './wk8-book-sentence.component.css',
})
export class Wk8BookSentenceComponent {
  readonly _lpVariablesService = inject(LpVariablesService);
  readonly _bookService = inject(Wk8BookService);

  sentence = input.required<LpWk8BookSentence>();
  enableLevelSelect = input.required<boolean>();
  enableWordFill = input.required<boolean>();
  target = input<LpWk8BookSentencePartFilter | undefined>(undefined);
  highlightedPart = input<LpWk8BookSentencePartFilter | undefined>(undefined);
  enableTarget = input<boolean>(true);
  dashArray = computed(() => {
    const patterns = ['16 16', '24 8', '8 8 8 8', '28 4', '12 4 4 12', '4 12 4 12']; // NOTE: these are variants of the dash pattern, could become useful later.
    return '16 16';
  });

  hovered = output<LpWk8BookSentencePartFilter | undefined>();
  wordFilled = output<[spot: LpWk8BookSentencePartFilter, word: LpWoordData | undefined]>();
  levelSelected = output<LpWk8BookSentencePartFilter>();

  getPartText(part: LpWk8BookSentencePart) {
    return this._bookService.getSentencePartValue(part);
  }

  draggableAdded(part: LpWk8BookSentencePartFilter, draggable: IDraggable) {
    this.wordFilled.emit([part, draggable.getContent() as LpWoordData]);
  }

  emptyTarget(part: LpWk8BookSentencePartFilter) {
    this.wordFilled.emit([part, undefined]);
  }
}
